// extracted by mini-css-extract-plugin
export var container = "_dp-0";
export var popoverContent = "_dp-1";
export var tosLink = "_dp-2";